WiseMetering.Views.ShowNextbittMaintenanceIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/nextbitt_maintenance/show',
    title: () => i18next.t('modal.title.integrations.show'),

    edit: function() {
        const href = `integration_licenses/${this.model.get('license_id')}/integrations/${this.model.id}/edit`;

        this.close();

        NavigationService.navigateTo(href, { trigger: true });
    },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site(),
            configurationName: this.model.configuration().get('name'),
            indicator: this.model.indicator(),
            integrationAssets: this.model.get('assets')
        };
    }
});
